import { render, staticRenderFns } from "./EditServer.vue?vue&type=template&id=64b97231&"
import script from "./EditServer.vue?vue&type=script&lang=js&"
export * from "./EditServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports